import React, { Component } from 'react';
import { Layout, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import AddAdjustLocation from './components/AddAdjustLocation';

const BreadcrumbItem = Breadcrumb.Item;

export default class AddLocation extends Component {
    render() {
        return (
            <Layout className="leadomatic-location-create-container">
                <Breadcrumb className="breadcrumbs">
                    <BreadcrumbItem><Link to="/PlatformManagement/Lead-o-matic_update">Lead-o-matic</Link></BreadcrumbItem>
                    <BreadcrumbItem>Add Location</BreadcrumbItem>
                </Breadcrumb>
                <h3 className="page-title">Add New Scrape Location</h3>
                <h3 className="page-subhead subhead">Add a new location to the Lead-o-matic service for scraping</h3>
                <AddAdjustLocation />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/index.js